import { GraphQLCompletionRequester } from '@cobliteam/api-lib';
import type { CompletionData } from '@cobliteam/api-lib/src/__generated__/graphql';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import useAuthStore from '../../useSession/store/useAuthStore';

const QUERY_KEY = 'COMPLETION_DATA';

type UseCompletionDataParams = {
  options?: Partial<UseQueryOptions<CompletionData | null>>;
};

const requester = new GraphQLCompletionRequester();

// A frota vai na key: depois de uma troca, o cache da frota anterior não é servido para a nova.
const completionDataQueryOptions = (fleetId: string | undefined) => ({
  queryKey: [QUERY_KEY, fleetId],
  queryFn: () => requester.getCompletionData(),
});

const useCompletionData = (params?: UseCompletionDataParams) => {
  const fleetId = useAuthStore((s) => s.session?.fleet.id);

  return useQuery<CompletionData | null>({
    ...params?.options,
    ...completionDataQueryOptions(fleetId),
    enabled: !!fleetId && (params?.options?.enabled ?? true),
  });
};

export { completionDataQueryOptions, QUERY_KEY, useCompletionData };
export default useCompletionData;
